import standardAPI from '@/api/standard_items';

const state = {
  tours_directions: [],
  tours_directions_status: '',
  tours_directions_MetaData: {},
  tours_directions_page: 1,
  tours_directions_perPage: 10,
};

const responseUrl = '/organisation-tours/directions';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_tours_directions ({ commit }, getOptions) {
    commit('TOURS_DIRECTIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('TOURS_DIRECTIONS_SUCCESS', response);
            commit('TOURS_DIRECTIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('TOURS_DIRECTIONS_READY');
            reject(response);
          } else {
            commit('TOURS_DIRECTIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_organisation_tours_direction ({ commit, dispatch }, itemData) {
    commit('TOURS_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('TOURS_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  edit_organisation_tours_direction ({ commit, dispatch }, itemData) {
    commit('TOURS_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('TOURS_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  remove_organisation_tours_direction ({ commit, dispatch }, itemData) {
    commit('TOURS_DIRECTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('TOURS_DIRECTIONS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_organisation_tours_direction ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_organisation_tours_direction_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.tours_directions_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.tours_directions_perPage = max;
  },
  TOURS_DIRECTIONS_READY: (state) => {
    state.tours_directions_status = 'ready';
  },
  TOURS_DIRECTIONS_REQUEST: (state) => {
    state.tours_directions_status = 'loading';
  },
  TOURS_DIRECTIONS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.tours_directions_MetaData.meta = response.meta;
      state.tours_directions_MetaData.links = response.links;
    }
    state.tours_directions = response.data;
    state.tours_directions_status = 'success';
  },
  TOURS_DIRECTIONS_ERROR: (state) => {
    state.tours_directions_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
